'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _effects = require('redux-saga/effects');

var _context11 = require('../../constants/actions/context');

var _getConfigurationSaga = require('./getConfigurationSaga');

var _getConfigurationSaga2 = _interopRequireDefault(_getConfigurationSaga);

var _getAnalyticsSaga = require('./getAnalyticsSaga');

var _getAnalyticsSaga2 = _interopRequireDefault(_getAnalyticsSaga);

var _setAnalyticsSaga = require('./setAnalyticsSaga');

var _setAnalyticsSaga2 = _interopRequireDefault(_setAnalyticsSaga);

var _getSessionSaga = require('./getSessionSaga');

var _getSessionSaga2 = _interopRequireDefault(_getSessionSaga);

var _setSessionSaga = require('./setSessionSaga');

var _setSessionSaga2 = _interopRequireDefault(_setSessionSaga);

var _expireSessionSaga = require('./expireSessionSaga');

var _expireSessionSaga2 = _interopRequireDefault(_expireSessionSaga);

var _getParametersSaga = require('./getParametersSaga');

var _getParametersSaga2 = _interopRequireDefault(_getParametersSaga);

var _setParametersSaga = require('./setParametersSaga');

var _setParametersSaga2 = _interopRequireDefault(_setParametersSaga);

var _getStorefrontUrlSaga = require('./getStorefrontUrlSaga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchConfiguration),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchGetAnalytics),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchSetAnalytics),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchGetSession),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchSetSession),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchExpireSession),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchGetParameters),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchSetParameters),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchGetStorefrontUrl),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(root);

function watchConfiguration() {
	return regeneratorRuntime.wrap(function watchConfiguration$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.takeLatest)(_context11.GET_CONFIGURATION, _getConfigurationSaga2.default);

				case 2:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}

function watchGetAnalytics() {
	return regeneratorRuntime.wrap(function watchGetAnalytics$(_context2) {
		while (1) {
			switch (_context2.prev = _context2.next) {
				case 0:
					_context2.next = 2;
					return (0, _effects.takeLatest)(_context11.GET_ANALYTICS, _getAnalyticsSaga2.default);

				case 2:
				case 'end':
					return _context2.stop();
			}
		}
	}, _marked2, this);
}

function watchSetAnalytics() {
	return regeneratorRuntime.wrap(function watchSetAnalytics$(_context3) {
		while (1) {
			switch (_context3.prev = _context3.next) {
				case 0:
					_context3.next = 2;
					return (0, _effects.takeLatest)(_context11.SET_ANALYTICS, _setAnalyticsSaga2.default);

				case 2:
				case 'end':
					return _context3.stop();
			}
		}
	}, _marked3, this);
}

function watchGetSession() {
	return regeneratorRuntime.wrap(function watchGetSession$(_context4) {
		while (1) {
			switch (_context4.prev = _context4.next) {
				case 0:
					_context4.next = 2;
					return (0, _effects.takeLatest)(_context11.GET_SESSION, _getSessionSaga2.default);

				case 2:
				case 'end':
					return _context4.stop();
			}
		}
	}, _marked4, this);
}

function watchSetSession() {
	return regeneratorRuntime.wrap(function watchSetSession$(_context5) {
		while (1) {
			switch (_context5.prev = _context5.next) {
				case 0:
					_context5.next = 2;
					return (0, _effects.takeLatest)(_context11.SET_SESSION, _setSessionSaga2.default);

				case 2:
				case 'end':
					return _context5.stop();
			}
		}
	}, _marked5, this);
}

function watchExpireSession() {
	return regeneratorRuntime.wrap(function watchExpireSession$(_context6) {
		while (1) {
			switch (_context6.prev = _context6.next) {
				case 0:
					_context6.next = 2;
					return (0, _effects.takeLatest)(_context11.EXPIRE_SESSION, _expireSessionSaga2.default);

				case 2:
				case 'end':
					return _context6.stop();
			}
		}
	}, _marked6, this);
}

function watchGetParameters() {
	return regeneratorRuntime.wrap(function watchGetParameters$(_context7) {
		while (1) {
			switch (_context7.prev = _context7.next) {
				case 0:
					_context7.next = 2;
					return (0, _effects.takeLatest)(_context11.GET_PARAMETERS, _getParametersSaga2.default);

				case 2:
				case 'end':
					return _context7.stop();
			}
		}
	}, _marked7, this);
}

function watchSetParameters() {
	return regeneratorRuntime.wrap(function watchSetParameters$(_context8) {
		while (1) {
			switch (_context8.prev = _context8.next) {
				case 0:
					_context8.next = 2;
					return (0, _effects.takeLatest)(_context11.SET_PARAMETERS, _setParametersSaga2.default);

				case 2:
				case 'end':
					return _context8.stop();
			}
		}
	}, _marked8, this);
}

function watchGetStorefrontUrl() {
	return regeneratorRuntime.wrap(function watchGetStorefrontUrl$(_context9) {
		while (1) {
			switch (_context9.prev = _context9.next) {
				case 0:
					_context9.next = 2;
					return (0, _effects.takeLatest)(_context11.GET_STOREFRONT_URL, _getStorefrontUrlSaga.getStorefrontUrlSaga);

				case 2:
				case 'end':
					return _context9.stop();
			}
		}
	}, _marked9, this);
}

function root() {
	return regeneratorRuntime.wrap(function root$(_context10) {
		while (1) {
			switch (_context10.prev = _context10.next) {
				case 0:
					_context10.next = 2;
					return (0, _effects.all)([(0, _effects.fork)(watchConfiguration), (0, _effects.fork)(watchGetAnalytics), (0, _effects.fork)(watchSetAnalytics), (0, _effects.fork)(watchGetSession), (0, _effects.fork)(watchSetSession), (0, _effects.fork)(watchExpireSession), (0, _effects.fork)(watchGetParameters), (0, _effects.fork)(watchSetParameters), (0, _effects.fork)(watchGetStorefrontUrl)]);

				case 2:
					return _context10.abrupt('return', _context10.sent);

				case 3:
				case 'end':
					return _context10.stop();
			}
		}
	}, _marked10, this);
}

exports.default = root;